import React from 'react';
import styled from 'styled-components';

import Skeleton from '@/components/atom/skeleton';

interface Props {
  size?: number;
}
const HospitalSkeletonList = ({ size = 8 }: Props) => {
  return (
    <SkeletonWrapper>
      {Array.from({ length: size }).map((_, i) => (
        <HospitalSkeleton key={`skeleton_hospital_${i}`} />
      ))}
    </SkeletonWrapper>
  );
};

export default HospitalSkeletonList;

const HospitalSkeleton = () => {
  return (
    <Card>
      <Skeleton style={{ width: 55, height: 18, marginBottom: 2 }} />
      <Skeleton style={{ width: 200, height: 24, marginBottom: 6 }} />
      <Skeleton style={{ width: 300, height: 22 }} />
    </Card>
  );
};

const Card = styled.li`
  padding: 24px;
  width: 100%;
  height: 120px;
  margin-bottom: 16px;
`;

const SkeletonWrapper = styled.ul`
  display: flex;
  flex-direction: column;
`;
